import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useHistory, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';

import { api } from '../../../services/api';
import { dateService } from '../../../services/date';

import CampaignsTab from './campaigns-tab';
import StrategiesTab from './strategies-tab';
import Chip from '../../ui/chip';
import { TabbedCards, Tab } from '../../ui/tabs';

import './campaign-center.scss';

const CampaignCenter = () => {
  const { merchantId } = useParams();
  const queryParams = new URLSearchParams(useLocation().search);
  const strategyGroupFilterId = queryParams.get('strategy_group_ids');
  const history = useHistory();

  const [topBarData, setTopBarData] = useState(null);

  useEffect(() => {
    const topBarEndpoint = strategyGroupFilterId
      ? `/api/v0/merchants/${merchantId}/strategies/${strategyGroupFilterId}/top_bar/`
      : `/api/v0/merchants/${merchantId}/strategies/top_bar/`;

    const params = {};

    if (!strategyGroupFilterId) {
      params.date_from = dateService.getFirstOfMonth(moment()).format('YYYY-MM-DD');
      params.date_to = moment().format('YYYY-MM-DD');
    }

    api.get(topBarEndpoint, params).then(resp => {
      const data = resp.data.data[0];

      setTopBarData(data.top_bar_info);
    });
  }, [strategyGroupFilterId]);

  const removeLinkedFilter = e => {
    e.stopPropagation();
    e.preventDefault();
    queryParams.delete('strategy_group_ids');
    history.replace({
      search: queryParams.toString(),
    });
  };

  return (
    <div className="campaign-center-page">
      <div className="header">
        <div className="page-name">Campaign Center</div>
      </div>
      <div className="body">
        <TabbedCards styleType="round" fallbackPath="budgets">
          <Tab
            path="budgets"
            name="Budgets"
            subLabelComponent={
              strategyGroupFilterId &&
              topBarData && (
                <Chip
                  text={topBarData.strategy_group_name}
                  actionIcon="x"
                  onAction={removeLinkedFilter}
                />
              )
            }
            isShowing={true}
            icon="campaigns"
            iconSide="left"
            render={() => <CampaignsTab topBarData={topBarData} merchantId={merchantId} />}
          />
          <Tab
            path="campaigns"
            name="Campaigns"
            subLabelComponent={
              strategyGroupFilterId && <span className="tab-sub-label">for 1 Budget</span>
            }
            isShowing={true}
            icon="strategies"
            iconSide="left"
            render={() => (
              <StrategiesTab
                topBarData={topBarData}
                merchantId={merchantId}
                strategyGroupFilterId={strategyGroupFilterId}
              />
            )}
          />
        </TabbedCards>
      </div>
    </div>
  );
};

CampaignCenter.propTypes = {};

CampaignCenter.defaultProps = {};

export default CampaignCenter;
